var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag"},[_c('div',{staticClass:"d-flex align-items-center"},[(_vm.color)?_c('v-swatch',{staticClass:"mr-5",attrs:{"color":_vm.color,"size":10,"radius":5}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }